"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.userColors = void 0;

var _vars = require("@devsta/ui-kit/dist/common/styles/vars"),
    userColors = [{
  color: _vars.COLOURS.userComment.cerulean,
  darken: !1
}, {
  color: _vars.COLOURS.userComment.heartfeltVermillion,
  darken: !0
}, {
  color: _vars.COLOURS.userComment.unsafeOchre,
  darken: !1
}, {
  color: _vars.COLOURS.userComment.snapMint,
  darken: !0
}, {
  color: _vars.COLOURS.userComment.shallowOrchid,
  darken: !0
}, {
  color: _vars.COLOURS.userComment.archetypal,
  darken: !1
}, {
  color: _vars.COLOURS.userComment.horseDrawnPansy,
  darken: !1
}, {
  color: _vars.COLOURS.userComment.gulliblePlatinum,
  darken: !0
}];

exports.userColors = userColors;